import React from "react"

import PropTypes from "prop-types"
import {Icon as SemanticIcon} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"
import ButtonPrimary from "../ButtonPrimary/buttonPrimary"

import "./style.scss"

const ChecklistTile = ({buttonLabel, checklistItems, disabled = false, icon, onClick, title}) => (
    <article className={`checklist-tile${disabled ? " disabled" : ""}`} data-testid={getDataTestId(title, "tuile")}>
        <SemanticIcon aria-hidden="true" className={`${icon} checklist-tile-icon`} />
        <span className="checklist-tile-title">{title}</span>
        <ul className="checklist-tile-list">
            {checklistItems.map(({checked, label}, index) => (
                <li className={checked ? "checked" : "unchecked"} key={index}>
                    <SemanticIcon aria-hidden="true" className={checked ? "fa-solid fa-check" : "fa-solid fa-xmark"} />
                    <span>{label}</span>
                </li>
            ))}
        </ul>
        <ButtonPrimary className="checklist-tile-button" disabled={disabled} onClick={onClick} size="small">
            {buttonLabel}
        </ButtonPrimary>
    </article>
)

ChecklistTile.propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    checklistItems: PropTypes.arrayOf(
        PropTypes.shape({
            checked: PropTypes.bool.isRequired,
            label: PropTypes.string.isRequired,
        }),
    ).isRequired,
    disabled: PropTypes.bool,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
}

export default ChecklistTile
